import { createContext, PropsWithChildren, useContext } from "react";

import { CheckoutCapabilities } from "./Checkout.policy";

interface CheckoutContextValue {
    capabilities: CheckoutCapabilities;
}

const CheckoutContext = createContext<CheckoutContextValue | null>(null);

interface CheckoutProviderProps extends PropsWithChildren {
    value: CheckoutContextValue;
}

export const CheckoutProvider = ({
    value,
    children,
}: CheckoutProviderProps) => (
    <CheckoutContext.Provider value={value}>
        {children}
    </CheckoutContext.Provider>
);

export const useCheckoutContext = () => {
    const context = useContext(CheckoutContext);

    if (!context) {
        throw new Error(
            "useCheckoutContext must be used within CheckoutProvider",
        );
    }

    return context;
};
